import { ParsedInvited } from './types';

const parseInvited = (data: ParsedInvited): ParsedInvited => ({
  email: data!.email || '',
  invited_fio: data!.invited_fio || '',
});

export default parseInvited;



// WEBPACK FOOTER //
// ./src/services/invite/utils/parseInvited.ts